export default {
  subtitle: {
    id: 'new_payment_result_success_subtitle',
    defaultMessage: 'And There you go!',
  },
  title: {
    id: 'new_payment_result_success_title',
    defaultMessage: 'Deal',
  },
  description: {
    id: 'payment_result_success_description',
    defaultMessage:
      'Thank you for your trust. Once your payment is confirmed, your order will be carefully prepared and sent by our {link, html} {merchants, html}.',
  },
  voucherDescription: {
    id: 'payment_result_voucher_whats_next',
    defaultMessage:
      'Once your payment is confirmed, your order will be carefully prepared and sent by our {link, html} {merchants, html}.',
  },
  merchants: {
    id: 'payment_result_success_merchants',
    defaultMessage: `{merchantCount, plural,
      one {merchant}
      other {merchants}
    }`,
  },
  followOrder: {
    id: 'new_payment_result_success_follow_order',
    defaultMessage: 'Track your order',
  },
  install: {
    id: 'new_payment_result_success_install',
    defaultMessage: 'Install our app to track delivery and stay in touch.',
  },
  steps: {
    id: 'new_payment_result_success_steps',
    defaultMessage: 'Here are the next steps',
  },
  step1: {
    id: 'new_payment_result_success_step1',
    defaultMessage:
      'We will send you the details of your order by email to the address:',
  },
  step2: {
    id: 'new_payment_result_success_step2',
    defaultMessage:
      'Remember to watch your spam and within a few days, we will ask you for news, just to see if you are satisfied.',
  },
  step3: {
    id: 'new_payment_result_success_step3',
    defaultMessage:
      'Until then, follow the status of your order from {account, html} on the site or mobile app.',
  },
  account: {
    id: 'new_payment_result_success_account',
    defaultMessage: 'your personal account',
  },
  sourcingOrderTitle: {
    id: 'payment_result_success_sourcing_order_title',
    defaultMessage: 'And for your buyback - {title}',
  },
  order: {
    id: 'payment_result_success_order',
    defaultMessage: 'Your order',
  },
  yourCoverageTitle: {
    id: 'insurance_summary_title',
    defaultMessage: 'Your coverage',
  },
  serviceFee: {
    id: 'payment_result_page_service_fee',
    defaultMessage: 'Back Market service fee',
  },
  total: {
    id: 'payment_result_page_total',
    defaultMessage: 'Total (tax included)',
  },
  relatedTitle: {
    id: 'payment_result_page_related_title',
    defaultMessage: 'This might interest you',
  },
  relatedProducts: {
    id: 'payment_result_page_related_products',
    defaultMessage: 'Related products to your order',
  },
}
